import { REFERRAL_TYPES } from "../../constants/gamification/referralTypes";

// Define the structure of the state
interface ReferralState {
  referralInfo: any;
  inviteResult: any;
  processResult: any;
  gamificationSummary: any;
}

// Define the type for the action
interface ReferralAction {
  type: string;
  payload: any;
}

// Initial state
const initialState: ReferralState = {
  referralInfo: null,
  inviteResult: null,
  processResult: null,
  gamificationSummary: null,
};

const referralReducer = (
  state = initialState,
  action: ReferralAction
): ReferralState => {
  switch (action.type) {
    case REFERRAL_TYPES.GET_USER_REFERRAL_INFO:
      return {
        ...state,
        referralInfo: action.payload,
      };
    case REFERRAL_TYPES.INVITE_USER:
      return {
        ...state,
        inviteResult: action.payload,
      };
    case REFERRAL_TYPES.PROCESS_REFERRAL:
      return {
        ...state,
        processResult: action.payload,
      };
    case REFERRAL_TYPES.GET_GAMIFICATION_SUMMARY:
      return {
        ...state,
        gamificationSummary: action.payload,
      };
    default:
      return state;
  }
};

export default referralReducer;